<template>
  <!-- <v-main> -->
    <v-container style="min-height:calc(100vh - 172px)" class="mt-3">
      <v-fade-transition mode="out-in">
        <!--The Main Content component go here-->
        <router-view></router-view>
      </v-fade-transition>
          <v-fab-transition>
            <v-menu top :offset-y="true" :close-on-content-click="false" :nudge-top="10">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="orange"
                  dark fixed
                  v-bind="attrs"
                  v-on="on"
                  bottom right fab >
                  <v-icon>mdi-message-reply</v-icon>
                </v-btn>
              </template>
              <v-card width="200px">
                <v-card-text>
                  <v-form @submit.prevent="sendFeedback">
                    <v-textarea label="Góp ý" color="orange" filled hide-details class="mb-3" v-model="feedBack.body">
                    </v-textarea>
                    <v-btn small right class="ml-auto" depressed color="teal" type="submit" dark> Gởi</v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-fab-transition>
    </v-container>
  <!-- </v-main> -->
</template>
<script>
// import SideBar from "@/components/SideBar.vue";
import http from '@/components/services/http-common';
export default {
    components:{
        // SideBar
    },
    computed:{
      webAllowed() {
          let user = localStorage.getItem("user");
          let webAllowed = localStorage.getItem("WebAllowed");
          user = JSON.parse(user);
        return webAllowed.includes(user.employeeCode);
      },
      items(){
          
          let data= [
            { title: "Chức năng", subheader:true},
            { title: "Danh sách phiếu hỗ trợ", icon: "mdi-toolbox", route:{name:"OcSupport"}, auth:'module:base' },
            { title: "Báo cáo tổng hợp", icon: "mdi-text-box-outline", route:{name:"OcEmployeeReport"}, auth:['module:base'], webAllowed: true },
            { title: "Phiếu công cụ, dụng cụ", icon: "mdi-text-box-outline", route:{name:"OcPropertyRequest"}, auth:['module:base'], webAllowed: true },
            { title: "Tiếp nhận phiếu cc/dc", icon: "mdi-text-box-check", route:{name:"OcPropertyRequestConfirm"}, auth:['module:base', 'prop:receive'], webAllowed: true },
            { title: "Cài đặt", subheader:true},
            { title: "Danh mục báo cáo", icon: "mdi-toolbox", route:{name:"OcEmployeeReportCategory"}, auth:"module:sysconfig" },
            { title: "Thiết bị", icon: "mdi-toolbox", route:{name:"OcProperty"}, auth:"module:sysconfig" },
            { title: "Danh mục check list", subheader:true},
            { title: "Kiểm tra hoạt động CN", icon: "mdi-text-box-check", route:{name:"StoreCheckList"}, auth:["ocAudit:read"], webAllowed: true },
            { title: "Báo cáo chi tiết kiểm tra", icon: "mdi-text-box-check", route:{name:"ReportCheckList"}, auth:["ocAudit:report"], webAllowed: true },
            { title: "Báo cáo tổng hợp kiểm tra", icon: "mdi-text-box-check", route:{name:"OcEmployeeReportSummerize"}, auth:["ocAudit:report"], webAllowed: true },
            { title: "Cài đặt hạng mục", icon: "mdi-text-box-check", route:{name:"SetupCheckList"}, auth:["ocAudit:settings"], webAllowed: true },
            { title: "Tra cứu", subheader:true},
            { title: "Tra cứu SM-Ch.nhánh", icon: "mdi-text-box-check", route:{name:"OcDepartmentSm"}, auth:["ocAudit:settings"], webAllowed: true },
            { title: "Báo cáo nội bộ", icon: "mdi-text-box-check", route:{name:"InternalDenouce"}, auth:["ocAudit:settings"], webAllowed: true },

            
          ]
        return data
      }
    },
    data() {
        return {
          feedBack: {
            body:"",
          }
        }
    },
    methods: {
      sendFeedback() {
        return http.post("feedbacks", this.feedBack).then(() => {
          console.log("feedback")
        })
      }
    },
    created(){
      this.$emit('updateSidebar', this.items);
    }
}
</script>